import styled from "styled-components";

export const StyledResults = styled.div`
  table {
    margin: 12px 0;
    border-collapse: collapse;
    text-align: center;
  }
  tr {
    border-bottom: 1px dashed #f2f2f239;
    
    th:first-child, td:first-child {
      border-right: 1px dashed #f2f2f239;
    }
  }
  tr:last-child { 
    border: none;
  }

  th, td {
    margin: 0;
    line-height: 1.4;
    padding: 12px 32px;
  }
`;